export default __webpack_public_path__ + "static/media/sir.fd511a40.jpg";